import * as api from "../api";

export const MaskService = {
    addNewMask,
    getOwnerMaskListWithoutPagination,
    getMaskListByOwnerId,
    getAllMaskList,
    changeMaskStatus,
    getOwnerMaskList,

};

async function getOwnerMaskList(formData, page, rowsPerPage) {
    try {
        const { data } = await api.getOwnerMaskList(formData, page, rowsPerPage);
        return {isSuccess: true, data: data};
    } catch (error) {

        return {isSuccess: false, data: error};
    }
}

async function getAllMaskList(formData, page, rowsPerPage) {
    try {
        const { data } = await api.getAllMaskList(formData, page, rowsPerPage);
        return {isSuccess: true, data: data};
    } catch (error) {

        return {isSuccess: false, data: error};
    }
}
async function getMaskListByOwnerId(formData, page, rowsPerPage) {
    try {
        const { data } = await api.getMaskListByOwnerId(formData, page, rowsPerPage);
        return {isSuccess: true, data: data};
    } catch (error) {

        return {isSuccess: false, data: error};
    }
}

async function addNewMask(formData) {
    try {
        const { data } = await api.addNewMask(formData);
        return {isSuccess: true, data: data};
    } catch (error) {

        return {isSuccess: false, data: error};
    }
}

async function changeMaskStatus(formData) {
    try {
        const { data } = await api.changeMaskStatus(formData);
        return {isSuccess: true, data: data};
    } catch (error) {

        return {isSuccess: false, data: error};
    }
}

async function getOwnerMaskListWithoutPagination() {
    try {
        const { data } = await api.getOwnerMaskListWithoutPagination();
        return {isSuccess: true, data: data};
    } catch (error) {

        return {isSuccess: false, data: error};
    }
}